<template>
  <div id="forms">
    <section class="suggestions">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="my-h1">{{ trans.get("b2b.footer.title") }}</h1>
            <p class="my-caps sub">{{ trans.get("b2b.footer.sugg-box") }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <ValidationObserver v-slot="{ invalid }">
              <form @submit.prevent="onSubmit">
                <div class="form-group">
                  <ValidationProvider
                      rules="min:8|max:40|required"
                      v-slot="{ errors }"
                  >
                    <label class="text-capitalize" for="referente">{{
                        trans.get("b2b.footer.contact")
                      }}</label>
                    <input
                        type="text"
                        class="form-control"
                        :class="errors[0] ? 'invalid' : ''"
                        id="referente"
                        v-model="suggestions.referente"
                    />
                    <small class="my-caps">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <ValidationProvider
                      rules="min:50|max:500|required"
                      v-slot="{ errors }"
                  >
                    <textarea
                        class="form-control"
                        :class="errors[0] ? 'invalid' : ''"
                        id="testo"
                        rows="7"
                        :placeholder="$trans('b2b.footer.message')"
                        v-model="suggestions.testo"
                    ></textarea>
                    <small>{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <ValidationProvider rules="true" v-slot="{ errors }">
                  <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="suggestions_acceptance"
                        value="true"
                        id="acceptance"
                    />
                    <label class="form-check-label" for="acceptance">
                      <a target=”_blank” :href="url('/b2b/privacy-policy')">
                        {{ trans.get("b2b.footer.privacy") }}
                      </a>

                    </label>
                    <small>{{ errors[0] }}</small>
                  </div>
                </ValidationProvider>

                <div class="my-buttons d-flex align-items-start mt-25px">
                  <div class="d-flex flex-column align-items-start">
                    <ValidationProvider
                        rules="image|size:2048"
                        ref="provider"
                        v-slot="{ errors }"
                    >
                      <div class="form-group">
                        <label
                            v-if="!suggestions.image"
                            class="allegato-btn my-btn-transparent"
                            :class="errors[0] ? 'invalid' : ''"
                            for="allegato"
                        >
                          <img
                              :src="url('/media/icons/svg/camera.svg')"
                              alt=""
                          />
                          <span>
                            <u>{{ trans.get("b2b.footer.attach-file") }}</u>
                          </span>
                        </label>
                        <div v-else>
                          <img class="loaded" :src="suggestions.image"/>
                          <button
                              class="btn btn-my-primary green w-100"
                              @click="removeImage"
                          >
                            {{ trans.get("b2b.footer.delete") }}
                          </button>
                        </div>
                      </div>

                      <input
                          type="file"
                          class="
                          form-control-file
                          link-ret
                          green
                          btn btn-my-primary
                          d-none
                        "
                          id="allegato"
                          @change="onFileChange"
                      />
                      <small class="file-error">{{ errors[0] }} </small>
                    </ValidationProvider>
                  </div>

                  <button
                      type="submit"
                      :disabled="invalid"
                      class="invia link-ret green btn-my-primary"
                      @click="suggestionsSubmit()"
                  >
                    {{ trans.get("b2b.footer.send") }}
                  </button>

                  <button
                      type="submit"
                      v-if="invalid"
                      class="invia link-ret green btn-my-primary disabled"
                  >
                    {{ trans.get("b2b.footer.send") }}
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </section>

    <section id="contact-us" class="contact-us">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="my-h1">{{ trans.get("b2b.footer.contact-us") }}</div>
          </div>
          <div class="col-md-6">
            <ValidationObserver v-slot="{ invalid }">
              <form @submit.prevent="onSubmit">
                <div class="form-group">
                  <ValidationProvider
                      rules="min:8|max:40|required"
                      v-slot="{ errors }"
                  >
                    <label class="text-capitalize" for="nome">{{
                        trans.get("b2b.footer.name")
                      }}</label>
                    <input
                        type="text"
                        class="form-control"
                        :class="errors[0] ? 'invalid' : ''"
                        id="nome"
                        v-model="contact_us.name"
                    />
                    <small>{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <ValidationProvider
                      rules="email|required"
                      v-slot="{ errors }"
                  >
                    <label for="email">{{
                        trans.get("b2b.footer.email")
                      }}</label>
                    <input
                        type="email"
                        class="form-control"
                        :class="errors[0] ? 'invalid' : ''"
                        id="email"
                        v-model="contact_us.email"
                    />
                    <small>{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <ValidationProvider rules="" v-slot="{ errors }">
                    <label class="text-capitalize" for="telefono">{{
                        trans.get("b2b.footer.phone")
                      }}</label>
                    <input
                        type="telefono"
                        class="form-control"
                        :class="errors[0] ? 'invalid' : ''"
                        id="tel"
                        v-model="contact_us.tel"
                    />
                    <small>{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <ValidationProvider
                      rules="min:8|max:50|required"
                      v-slot="{ errors }"
                  >
                    <label class="text-capitalize" for="object">{{
                        trans.get("b2b.footer.subject")
                      }}</label>
                    <input
                        type="text"
                        class="form-control"
                        :class="errors[0] ? 'invalid' : ''"
                        id="object"
                        v-model="contact_us.object"
                    />
                    <small>{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <ValidationProvider
                      rules="min:50|max:500|required"
                      v-slot="{ errors }"
                  >
                    <label class="text-capitalize" for="messaggio">{{
                        trans.get("b2b.footer.message")
                      }}</label>
                    <textarea
                        class="form-control"
                        :class="errors[0] ? 'invalid' : ''"
                        id="messaggio"
                        rows="6"
                        v-model="contact_us.msg"
                    ></textarea>
                    <small>{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-check">
                  <ValidationProvider rules="true" v-slot="{ errors }">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="contact_us_acceptance"
                        value="true"
                        id="contact_acceptance"
                    />
                    <label class="form-check-label-2" for="contact_acceptance">
                      <a target=”_blank” :href="url('/b2b/privacy-policy')">
                        {{ trans.get("b2b.footer.privacy") }}
                      </a>
                    </label>
                    <small>{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <button
                    type="submit"
                    class="mt-25px invia link-ret green btn-my-primary"
                    :disabled="invalid"
                    @click="contactSubmit()"
                >
                  {{ trans.get("b2b.footer.send") }}
                </button>

                <button
                    type="submit"
                    v-if="invalid"
                    class="invia link-ret green btn-my-primary disabled"
                >
                  {{ trans.get("b2b.footer.send") }}
                </button>
              </form>
            </ValidationObserver>
          </div>
          <div class="col-md-6">
            <div class="recapiti">
              <h3 class="text-capitalize my-h3">
                {{ trans.get("b2b.footer.contacts") }}
              </h3>
              <p class="text-capitalize">
                {{ details.citta }} {{ details.nazione }}
              </p>
              <p class="text-capitalize">{{ details.indirizzo }}</p>
              <p class="text-capitalize">{{ details.tel1 }}</p>
              <p class="text-capitalize">{{ details.tel2 }}</p>
              <p class="my-caps">{{ trans.get("b2b.footer.social") }}</p>
              <ul class="icons d-flex justify-content-between">
                <li v-for="(social, i) in socials" :key="i">
                  <a class="icon" :href="social.link">
                    <i :class="'fab fa-' + social.icon"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="messaggio-successo" v-if="successo !== ''">
      {{ successo }}
    </div>

    <div v-if="privacy == true" class="privacy">
      <privacy @close="closePrivacy()"/>
    </div>
  </div>
</template>

<script>
import {ValidationObserver} from "vee-validate";
import {ValidationProvider} from "vee-validate";
import privacy from "./privacy";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    privacy,
  },

  data: function () {
    return {
      privacy: false,
      successo: "",
      suggestionsReceived: {},
      suggestions: {
        referente: "",
        testo: "",
        immagine: "",
        image: "",
      },
      suggestions_acceptance: false,
      contact_us: {
        name: "",
        email: "",
        tel: "",
        object: "",
        msg: "",
      },
      contact_us_acceptance: false,
      socials: [
        {
          icon: "instagram",
          link: "https://www.instagram.com/4belt_italy/",
        },
        {
          icon: "facebook-f",
          link: "https://www.facebook.com/thermoweldable",
        },
        {
          icon: "linkedin-in",
          link: "https://www.linkedin.com/company/4-belt/",
        },
      ],
      details: {
        citta: "Maerne di Martellago - Venice",
        nazione: "Italy",
        indirizzo: "Via Cacace, 8",
        tel1: "+39 041 5030759",
        tel2: "+39 041 641799",
      },
    };
  },
  mounted: function () {
  },
  methods: {
    closePrivacy: function () {
      this.privacy = false;
    },
    onSubmit() {
      //alert("Form has been submitted!");
    },
    suggestionsSubmit() {
      this.suggestionsReceived = {};
      this.suggestionsReceived = this.suggestions;
      this.suggestions = {
        referente: "",
        testo: "",
        immagine: "",
      };
      //console.log(this.suggestionsReceived);
      var here = this;

      let dati = new FormData();
      dati.append("action", "suggestion");
      dati.append("referente", here.suggestionsReceived.referente);
      dati.append("testo", here.suggestionsReceived.testo);
      dati.append("immagine", here.suggestionsReceived.immagine);

      axios({
        method: "post",
        url: window.location.origin + "/b2b/communications",
        headers: {
          "content-type": "multipart/form-data",
        },
        data: dati,
      })
          .then((res) => {
            // console.log(res.data);
            if (res.data.success) {
              this.success();
            }
          })
          .catch((error) => {
            // console.log(error.response);
          });
    },
    contactSubmit() {
      axios({
        method: "post",
        url: window.location.origin + "/b2b/communications",
        params: {
          action: "contact-us",
          nome: this.contact_us.name,
          email: this.contact_us.email,
          telefono: this.contact_us.tel,
          object: this.contact_us.object,
          messaggio: this.contact_us.msg,
        },
      })
          .then((res) => {
            // console.log(res.data);
            if (res.data.success) {
              this.success();
            }
          })
          .catch((error) => {
            // console.log(error.response);
          });

      this.contact_us = {
        name: "",
        email: "",
        tel: "",
        object: "",
        msg: "",
      };

      // console.log(this.contactReceived);
    },
    success() {
      this.successo = "Il tuo messaggio è stato recapitato.";
      setTimeout(() => {
        this.successo = "";
        this.$emit("refresh", true);
      }, 2000);
    },

    async onFileChange(e) {
      var vue = this;
      const {valid} = await this.$refs.provider.validate(e);

      if (valid) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;

        // console.log(e.target.files[0]);
        vue.suggestions.immagine = e.target.files[0];

        this.createImage(files[0]);
      }
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vue = this;

      reader.onload = (e) => {
        vue.suggestions.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      this.suggestions.image = "";
      this.suggestions.immagine = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.messaggio-successo {
  position: fixed;
  display: inline-block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  padding: 50px;
  background-color: var(--greenb2b);
  color: #000;
}

.form-group,
.mt-25px {
  margin-top: 25px;
}

#forms {
  background-color: #26262a;
  color: #fff;
  padding-bottom: 236px;

  button[disabled="disabled"] {
    display: none;
  }

  button.disabled {
    &:hover {
      cursor: initial;
      background-color: var(--greenb2b);
      border: 1px solid var(--greenb2b);
      box-shadow: none;
      color: var(--dark-gray);

      &:after {
        left: -1.6em;
      }
    }
  }

  input,
  textarea {
    border-radius: 0;
    background-color: inherit;
    color: #fff;

    &::placeholder {
      color: #fff;
      font-weight: 400;
    }

    &:focus {
      border-color: var(--greenb2b);
      box-shadow: 0 0 0 0.2rem rgba(166, 249, 52, 0.25);
    }

    &.invalid {
      border-color: var(--red);
      box-shadow: 0 0 0 0.2rem rgba(255, 35, 61, 0.25);
    }
  }

  small {
    color: var(--red);

    &.file-error {
      margin-left: -30px;
      margin-right: 20px;
    }
  }

  .invia {
    width: 342px;
  }

  section {
    padding-top: 93px;

    form {
      margin-top: 62px;
    }
  }

  .suggestions {
    .sub {
      margin-top: 22px;
    }

    .my-buttons {
      flex-direction: column;

      .form-group {
        margin: 0;
        margin-right: 0;

        .allegato-btn {
          min-width: 243px;
          margin: 0;

          &.my-btn-transparent.invalid {
            border-color: var(--red);
            box-shadow: 0 0 0 0.2rem rgba(255, 35, 61, 0.25);
            color: var(--red);
          }

          img {
            margin-right: 20px;
          }
        }

        .loaded {
          width: 163.11px;
        }
      }

      .invia {
        margin-top: 25px;
      }
    }
  }

  .recapiti {
    padding-left: 80px;
    padding-top: 90px;

    p {
      margin-bottom: 26px;

      &:last-of-type {
        margin-top: 76px;
      }
    }
  }

  h3 {
    margin-bottom: 42px;
  }

  .icons {
    width: 166px;

    .icon {
      color: #26262a;
      padding: 14px;
      background-color: #fff;
      border-radius: 50%;
      font-size: 20px;

      .fab.fa-instagram, .fab.fa-linkedin-in {
        margin-left: 2px;
      }

      &:hover {
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
}
.form-check-label-2{
  margin-bottom: 20px;
}
@media screen and (min-width: 768px) {
  #forms {
    .suggestions {
      .my-buttons {
        flex-direction: row;

        .form-group {
          margin: 0;
          margin-right: 41px;

          .allegato-btn {
            min-width: 243px;
            margin: 0;

            img {
              margin-right: 20px;
            }
          }

          .loaded {
            width: 163.11px;
          }
        }

        .invia {
          margin-top: 0;
        }
      }
    }
  }
}

@media screen and (min-width: 992px) {
  .recapiti {
    padding-left: 166px;
  }
}
</style>
